import { render, staticRenderFns } from "./bookList.vue?vue&type=template&id=52270318&scoped=true"
import script from "./bookList.vue?vue&type=script&lang=js"
export * from "./bookList.vue?vue&type=script&lang=js"
import style0 from "./bookList.vue?vue&type=style&index=0&id=52270318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52270318",
  null
  
)

export default component.exports